import React, { useCallback, useContext } from 'react';
import EDMenu from '../../../../BaseComponents/Menu/EDMenu';
import EDMenuItem from '../../../../BaseComponents/Menu/EDMenuItem';
import { TSelectedDetail } from '../../../../Types/MasterDetailTypes';
import { ICustomAddButtonProps } from '../../_Common/Const/Delsystem';
import { NewId } from '../../../../Components/MasterDetail/MasterDetailUtils';
import { ActiveDatabaseContext } from '../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import {
  hasRutinKod,
  isReadOnlyRutin,
} from '../ObjektVyer/Aktivitet/Utils/AktivitetUtils';
export const AktivitetTypCellMeny: React.FC<
  React.PropsWithChildren<
    ICustomAddButtonProps & {
      anchorEl?: HTMLElement | null;
      open?: boolean;
      onClose?: () => void;
      onSelectDetail?: (id: TSelectedDetail) => void;
    }
  >
> = props => {
  const { onSelectDetail, onClose } = props;
  const databaseContext = useContext(ActiveDatabaseContext);
  const availableRoutines = databaseContext.availableRoutines;

  const onClick1 = useCallback(() => {
    onSelectDetail?.({ id: NewId, customDetailData: 'GUDSTJANST' }),
      onClose?.();
  }, [onSelectDetail, onClose]);
  const onClick2 = useCallback(() => {
    onSelectDetail?.({ id: NewId, customDetailData: 'AKTOVRIGT' }), onClose?.();
  }, [onSelectDetail, onClose]);

  if (
    !hasRutinKod('rtnWebKalender', availableRoutines) ||
    isReadOnlyRutin('rtnWebKalender', availableRoutines)
  ) {
    return null;
  }
  return (
    <EDMenu
      onClose={props.onClose}
      anchorEl={props.anchorEl}
      open={Boolean(props.open)}
      id={props.setNewObject?.toString()}
    >
      {hasRutinKod('rtnWebBokaGudstjanst', availableRoutines) &&
        !isReadOnlyRutin('rtnWebBokaGudstjanst', availableRoutines) &&
        hasRutinKod('rtnWebKalender', availableRoutines) && (
          <EDMenuItem onClick={onClick1}>Gudstjänst</EDMenuItem>
        )}
      {hasRutinKod('rtnWebKalender', availableRoutines) && (
        <EDMenuItem onClick={onClick2}>Övrig aktivitet</EDMenuItem>
      )}
    </EDMenu>
  );
};
